var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !!_vm.selectedChat
    ? _c(
        "div",
        { attrs: { id: "department-chat-sidebar" } },
        [
          _c(
            "div",
            { staticClass: "head" },
            [
              [
                _c(
                  "a-dropdown",
                  {
                    attrs: { trigger: ["click"] },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "overlay",
                          fn: function () {
                            return [
                              _c(
                                "a-menu",
                                { attrs: { id: "dropdown-menu" } },
                                [
                                  _c(
                                    "a-menu-item",
                                    { key: "0", staticClass: "menu-item" },
                                    [
                                      _c("input", {
                                        attrs: {
                                          id: "change-pp",
                                          type: "file",
                                          accept:
                                            "image/png, image/jpeg, image/gif",
                                        },
                                        on: { change: _vm.uploadFile },
                                      }),
                                      _vm._v(" "),
                                      _vm.groupProfilePicture ||
                                      _vm.$_.get(
                                        _vm.selectedChat,
                                        "meta.groupThread.groupProfilePicture"
                                      )
                                        ? _c(
                                            "label",
                                            { attrs: { for: "change-pp" } },
                                            [
                                              _c("a", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.changePhoto"
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          )
                                        : _c(
                                            "label",
                                            { attrs: { for: "change-pp" } },
                                            [
                                              _c("a", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("message.addPhoto")
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.groupProfilePicture ||
                                  _vm.$_.get(
                                    _vm.selectedChat,
                                    "meta.groupThread.groupProfilePicture"
                                  )
                                    ? _c(
                                        "a-menu-item",
                                        { key: "1", staticClass: "menu-item" },
                                        [
                                          _c(
                                            "a",
                                            { on: { click: _vm.showViewer } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("message.seePhoto")
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.groupProfilePicture ||
                                  _vm.$_.get(
                                    _vm.selectedChat,
                                    "meta.groupThread.groupProfilePicture"
                                  )
                                    ? _c("a-menu-divider")
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.groupProfilePicture ||
                                  _vm.$_.get(
                                    _vm.selectedChat,
                                    "meta.groupThread.groupProfilePicture"
                                  )
                                    ? _c(
                                        "a-menu-item",
                                        {
                                          key: "2",
                                          staticClass: "menu-item",
                                          attrs: { id: "delete-option" },
                                          on: { click: _vm.deleteProfilePhoto },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("message.deletePhoto")
                                            ) + "\n                        "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      3020995691
                    ),
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "ant-dropdown-link",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                          },
                        },
                      },
                      [
                        _c(
                          "label",
                          { staticClass: "imgUpload" },
                          [
                            _vm.groupProfilePicture ||
                            _vm.$_.get(
                              _vm.selectedChat,
                              "meta.groupThread.groupProfilePicture"
                            )
                              ? _c("a-avatar", {
                                  attrs: {
                                    id: "department-summary-avatar",
                                    src:
                                      _vm.groupProfilePicture ||
                                      _vm.$_.get(
                                        _vm.selectedChat,
                                        "meta.groupThread.groupProfilePicture"
                                      ),
                                    size: 84,
                                  },
                                })
                              : _c("department-chat-icon", {
                                  attrs: { id: "department-chat-icon" },
                                }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                ),
              ],
              _vm._v(" "),
              _c(
                "a-modal",
                {
                  attrs: {
                    id: "groupViewerModal",
                    visible: _vm.isImageViewerShow,
                    footer: false,
                  },
                  on: { cancel: _vm.closeViewer },
                },
                [
                  _c("img", {
                    attrs: {
                      src:
                        _vm.groupProfilePicture ||
                        _vm.$_.get(
                          _vm.selectedChat,
                          "meta.groupThread.groupProfilePicture"
                        ),
                    },
                  }),
                ]
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "user-name" }, [
            _vm._v(_vm._s(_vm.getName(_vm.selectedChat))),
          ]),
          _vm._v(" "),
          _vm.mediaSlideVisible
            ? _c("MediaSlide", {
                on: {
                  "close-media-slide": function ($event) {
                    _vm.mediaSlideVisible = false
                  },
                },
              })
            : _c("div", { staticClass: "user-info" }, [
                _c(
                  "div",
                  {
                    staticClass: "media-row",
                    on: {
                      click: function ($event) {
                        _vm.mediaSlideVisible = true
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "media-text" }, [
                      _vm._v(" " + _vm._s(_vm.$t("message.sumChat_MediaFile"))),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "material-icons media-btn" }, [
                      _vm._v("arrow_forward"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "user-info-head" }, [
                  _vm._v(_vm._s(_vm.$t("message.userInformations"))),
                ]),
                _vm._v(" "),
                _vm.onlineDepartmentUsers.length > 0
                  ? _c(
                      "div",
                      { staticClass: "user-list" },
                      [
                        _c("p", { attrs: { id: "online-users-label" } }, [
                          _vm._v(_vm._s(_vm.$t("message.online"))),
                        ]),
                        _vm._v(" "),
                        _vm._l(
                          _vm.onlineDepartmentUsers,
                          function (departmentUser) {
                            return _c("div", [
                              _c(
                                "div",
                                {
                                  staticClass: "department-user-info",
                                  on: {
                                    click: function ($event) {
                                      departmentUser.userDetailVisible =
                                        !departmentUser.userDetailVisible
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "department-user-item" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "avatarContainer" },
                                        [
                                          _c("AgentAvatar", {
                                            staticClass:
                                              "department-agents-avatar",
                                            attrs: {
                                              "user-i-d": departmentUser._id,
                                              size: 30,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "nameContainer" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "tooltip-container",
                                              attrs: {
                                                title: departmentUser.name,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(departmentUser.name) +
                                                  "\n                            "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "material-icons dm-message-btn",
                                      on: {
                                        click: function ($event) {
                                          return _vm.directMessage(
                                            departmentUser
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("message")]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              departmentUser.userDetailVisible
                                ? _c(
                                    "div",
                                    _vm._l(_vm.datas, function (data) {
                                      return _c(
                                        "div",
                                        { staticClass: "agent-item-detail" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "material-icons",
                                              staticStyle: {
                                                color: "#e7957f",
                                                "font-size": "15px",
                                                "max-width": "22px",
                                                "margin-right": "5px",
                                              },
                                              attrs: { id: "" },
                                            },
                                            [_vm._v(_vm._s(data.icon))]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "poped_datas",
                                              attrs: {
                                                title:
                                                  data.slot === "email"
                                                    ? departmentUser[data.slot]
                                                    : null,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(
                                                    departmentUser[data.slot]
                                                  ) +
                                                  "\n                        "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                : _vm._e(),
                            ])
                          }
                        ),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.offlineDepartmentUsers.length > 0
                  ? _c(
                      "div",
                      { staticClass: "user-list" },
                      [
                        _c("p", { attrs: { id: "offline-users-label" } }, [
                          _vm._v(_vm._s(_vm.$t("message.offline"))),
                        ]),
                        _vm._v(" "),
                        _vm._l(
                          _vm.offlineDepartmentUsers,
                          function (departmentUser) {
                            return _c("div", [
                              _c(
                                "div",
                                {
                                  staticClass: "department-user-info",
                                  on: {
                                    click: function ($event) {
                                      departmentUser.userDetailVisible =
                                        !departmentUser.userDetailVisible
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "department-user-item" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "avatarContainer" },
                                        [
                                          _c("AgentAvatar", {
                                            staticClass:
                                              "department-agents-avatar",
                                            attrs: {
                                              "user-i-d": departmentUser._id,
                                              size: 30,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "nameContainer" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "tooltip-container",
                                              attrs: {
                                                title: departmentUser.name,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(departmentUser.name) +
                                                  "\n                            "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "material-icons dm-message-btn",
                                      on: {
                                        click: function ($event) {
                                          return _vm.directMessage(
                                            departmentUser
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("message")]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              departmentUser.userDetailVisible
                                ? _c(
                                    "div",
                                    _vm._l(_vm.datas, function (data) {
                                      return _c(
                                        "div",
                                        { staticClass: "agent-item-detail" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "material-icons",
                                              staticStyle: {
                                                color: "#e7957f",
                                                "font-size": "15px",
                                                "max-width": "22px",
                                                "margin-right": "5px",
                                              },
                                              attrs: { id: "" },
                                            },
                                            [_vm._v(_vm._s(data.icon))]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "poped_datas",
                                              attrs: {
                                                title:
                                                  data.slot === "email"
                                                    ? departmentUser[data.slot]
                                                    : null,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(
                                                    departmentUser[data.slot]
                                                  ) +
                                                  "\n                        "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                : _vm._e(),
                            ])
                          }
                        ),
                      ],
                      2
                    )
                  : _vm._e(),
              ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }